import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";


import styles from "assets/jss/material-kit-react/components/admin/fullWidthImage.js";

const useStyles = makeStyles(styles);

export default function FullWidthImage(props) {
  const classes = useStyles();
  const { image } = props;
  return (
    <div className={classes.section}>
      <div  className={classes.box}>
        <div>
          <img alt="جشنواره دوره های دانشگاه صنعتی شریف" className={classes.image} src={image}/>
        </div>
      </div>
    </div>
  );
}
